import { authHeader } from '../_helpers';
import request from '../_helpers/request';
import axios from 'axios'; 

const langid=localStorage.getItem('currentLangId');
//console.log(UserMsg.empCompanyId);


export const CompanyInfoService = {
  UpdatePrivewStrus,
  GetAIPreviewHeader,
  GetCompanyInfoAsync,
  GetCountryList,
  GetIndustryList,
  GetProductCatList,
  GetAllProductCategories,
  GetCellCountryData,
  GetPhoneValidCode,
  GetEmailValidCode, 
  SaveCompanyInfo,
  SubmitCompanyInfo,
  checkEmailValidCode,
  UpdateContactValidate,
  GetCompanyOtherInfo,
  CheckCatalogAndIndustrys,
  GetCompanyQRCode,
  GetCompanyProfile,
  GetContactAndEnquiry,
  GetCompanyIntro,
  GetCompanyCert,
  GetClientList,
  SaveCompanyProfile,
  SaveContactAndEnquiry,
  SaveCompanyIntro,
  SaveClientList,
  SaveCompanyCert,
  GetProvList,
  GetCompanyRegions,
  GetProductAndAdCheckItem,
  GetCompanyLogo,
  checkValidCode,
  SyncCompanyToFrontEnd,
  GetCompanyApprovalStatus,
  GetCompanyApprovalDetail,
  UpdateCompanyRejectReason,
  UpdateCompanyOverallRejectReason,
  CompanyApprove,
  DelistCompany,
};
async function UpdatePrivewStrus(data){
  return await request({
    url: 'Company/UpdatePrivewStrus',
    method: 'post',
    data: data
  });
  
}
async function GetAIPreviewHeader(companyid){
  return await request({
    url: 'Company/GetAIPreviewHeader',
    method: 'get',
    params: {"CmpanyId":companyid}
  });
  
}
//获公司资料信息
async function GetCompanyInfoAsync(query) {
    return await request({
      url: 'Company/GetCompanyInfoByCompanyId',
      method: 'get',
      params: query
    });
}
async function   SaveCompanyInfo(data) {
    return await request({
      url: 'Company/SaveCompanyInfo',
      method: 'post',
      data: data
    });
}
function SubmitCompanyInfo(query) {
 // let UserMsg = JSON.parse(localStorage.getItem('user'));

//   var query={
//     "empId":parseInt(UserMsg.empCompanyId),
//     "userId":UserMsg.login
//   }; 
// var dataStr="empId=1000027&userId=EMP_1007347";
  return request({
    url: 'Company/SubmitCompanyInfo',
    method: 'post',
    params:query
  });
}
// 国家
 function GetCountryList() {
  var querySet={
    Langid:langid
  };
  querySet.Langid=localStorage.getItem('currentLangId');
  return  request({
    url: 'Company/GetCountryList',
    method: 'get',
    params: querySet,
    
  }); 
}
// 省区
function GetProvList() {
  return  request({
    url: 'Company/GetProvList',
    method: 'get'
  }); 
}
//  行业
function GetIndustryList() {

  var paramsIndustry = {
    'ExhId':480,
    'langId': 936     
    };
    var lang=localStorage.currentLangId;
    paramsIndustry.langId=lang;

  return  request({
    url: 'Company/GetIndustryList',
    method: 'get',
    params:paramsIndustry,
     
  }); 
}

//  品类
function GetProductCatList() {
  var paramsProductCat = {
    'ExhId':480,
    'langId': 936     
    };
    var lang=localStorage.currentLangId;
    paramsProductCat.langId=lang;
  return  request({
    url: 'Company/GetProductCatList',
    method: 'get',
    params: paramsProductCat,
    
  }); 
}
 //新版
function GetAllProductCategories() {
  var paramsProductCat = {
    'langId': 936     
    };
    var lang=localStorage.currentLangId;
    paramsProductCat.langId=lang;
  return  request({
    url: 'Company/GetAllProductCategories',
    method: 'get',
    params: paramsProductCat,
    
  }); 
}
//获取国家区号
 
async function GetCellCountryData() { 
  let host = 'https://e.adsale.com.hk'; //请求域名
  var params={ 'ShowCode':'CPS23','LangId':langid };
  var url=host+'/GeniusAnalyst/api/AppApi/GetShowPreregOptionData_Mychinaplas_Cloud'; 
  return await axios({  
    method:'post',  
    url:url,  
    data:params,   
    transformRequest: function (data) {
      return JSON.stringify(data); //重新处理提交参数
    },
    headers: { 'Content-Type': 'application/json' },  
  }).then((res)=>{ 
    return res.data.CountryList;
  }).catch(function (error) {
    console.log(error);
  });
}


//发送短信验证码
function GetPhoneValidCode(params) {
  let host = 'https://e.adsale.com.hk'; //请求域名
 var langid=localStorage.getItem('currentLangId');
 var showid= params.IsUat ? 9981 : 9991;
 var typename = "CPS_Login";
  var url =host+ '/vreg/Content/handler/MobileCode.ashx?Handler=GetCode&CellNum='+params.phoneNumber +  '&RLang=' + langid + '&showid=' + showid + '&subject=EMPBackend';
  if(params.area!='86') {
      params.phoneNumber= params.area+params.phoneNumber;
      url=host+ '/vreg/Content/handler/IntelMobileCode.ashx?Handler=GetCode&CellNum='+params.phoneNumber +  '&RLang=' + langid + '&showid=' + showid+'&ProjectCode=\'CPS22DB\'' + '&subject=EMPBackend';
  }
  url += "&guid="+params.guid+"&captcha_type=geetest&lot_number=" + params.lot_number + "&captcha_output=" + params.captcha_output + "&pass_token=" + params.pass_token + "&gen_time=" + params.gen_time+"&typename="+params.typename+ "&IsUAT="+params.IsUat;
  return axios({
      method: 'get',
      url: url,
      withCredentials: false
    }).then(res => {
      return res;
    });
}

//var  data = "Handler=GetEmailCode&CellNum=" + val + "&RLang=@Model.LangId&showid=@showId&Subject=MYCHINAPLAS" + "&captcha_ticket=" + captcha_ticket + "&captcha_randstr=" + captcha_randstr + "&captcha_type=" + captcha_type + "&captcha_nctoken=" + captcha_nctoken;
//var  url = "@RE.GetDomain(DomainUrl.Prereg)/vreg/Content/handler/MobileCode.ashx";

//发送邮箱验证码
function GetEmailValidCode(params) {
  let host = 'https://e.adsale.com.hk'; //请求域名
 var langid=localStorage.getItem('currentLangId');
 var showid=9991;
  var url=host+ '/vreg/Content/handler/MobileCode.ashx?Handler=GetEmailCode&CellNum='+params.email +  '&RLang=' + langid + '&showid=' + showid + '&subject=EMPBackend';
  
  url +="&guid="+params.guid+ "&captcha_type=geetest&lot_number=" + params.lot_number + "&captcha_output=" + params.captcha_output + "&pass_token=" + params.pass_token + "&gen_time=" + params.gen_time+"&typename="+params.typename+ "&IsUAT="+params.IsUat;
  return axios({
      method: 'get',
      url: url,
      withCredentials: false
    }).then(res => {
      return res;
    });
}
//验证验证码(手机和邮箱通用)
function checkEmailValidCode(params) {
  let host = 'https://e.adsale.com.hk'; //请求域名 

  var url=host+ '/vreg/Content/handler/MobileCode.ashx?Handler=RepeatedlyVerifiCode&Guid=' + params.guid + '&Code=' + params.code + '&subject=EMPBackend' + '&ISTemp=true&Url=';
  return axios({
      method: 'get',
      url: url,
      withCredentials: false
    }).then(res => {
      return res;
    });
}

//验证验证码(手机和邮箱通用)
function checkValidCode(params) {
  let host = 'https://e.adsale.com.hk'; //请求域名 

  var url=host+ '/vreg/Content/handler/MobileCode.ashx?Handler=RepeatedlyVerifiCode&Guid=' + params.guid + '&Code=' + params.code + '&subject=EMPBackend' + '&ISTemp=true&Url=';
  return axios({
      method: 'get',
      url: url,
      withCredentials: false
    }).then(res => {
      return res;
    });
}
//更新验证码状态
//  品类
function UpdateContactValidate(companyid,updateType,contactPhoneCountryCode,contactPhoneCountry,value) {
  let UserMsg = JSON.parse(localStorage.getItem('user'));
  // var EmpId=UserMsg.empCompanyId;
  var userId=UserMsg.login;
  return  request({
    url: 'Company/UpdateContactValidate?updateType='+updateType+'&EmpId='+companyid+'&userId='+userId+'&contactPhoneCountryCode='+contactPhoneCountryCode+'&contactPhoneCountry='+contactPhoneCountry+'&value='+value,
    method: 'get',
    params: {},
    
  }); 
}


/*
 获取公司(提交时间，提交次数)
*/
function GetCompanyOtherInfo(query){
  return request({
    url:'Company/GetCompanyOtherInfo',
    method:'post',
    params:query
  });
}

function CheckCatalogAndIndustrys(query){
  return request({
    url:'Company/CheckCatalogAndIndustrys',
    method:'post',
    params:query
  });
}

function GetCompanyQRCode(query){
  return request({
    url:'Company/GetCompanyQRCode',
    method:'post',
    params:query
  })
}

function GetCompanyProfile(companyId, useFormalTables)
{
  return request({
    url:'Company/GetCompanyProfile',
    method:'post',
    params:{"companyId":companyId, "useFormalTables": !!useFormalTables}
  })
}

function GetContactAndEnquiry(companyId, useFormalTables)
{
  return request({
    url:'Company/GetContactAndEnquiry',
    method:'post',
    params:{"companyId":companyId, "useFormalTables": !!useFormalTables}
  })
}
function GetCompanyIntro(companyId, useFormalTables)
{
  return request({
    url:'Company/GetCompanyIntro',
    method:'post',
    params:{"companyId":companyId, "useFormalTables": !!useFormalTables}
  })
}
function GetCompanyCert(companyId, useFormalTables)
{
  return request({
    url:'Company/GetCompanyCert',
    method:'post',
    params:{"companyId":companyId, "useFormalTables": !!useFormalTables}
  })
}
function GetClientList(companyId, useFormalTables)
{
  return request({
    url:'Company/GetClientList',
    method:'post',
    params:{"companyId":companyId, "useFormalTables": !!useFormalTables}
  })
}

function SaveCompanyProfile(data)
{
  return request({
    url:'Company/SaveCompanyProfile',
    method:'post',
    data:data
  })
}
function SaveContactAndEnquiry(data)
{
  return request({
    url:'Company/SaveContactAndEnquiry',
    method:'post',
    data:data
  })
}
function SaveCompanyIntro(data)
{
  return request({
    url:'Company/SaveCompanyIntro',
    method:'post',
    data:data
  })
}
function SaveClientList(data)
{
  return request({
    url:'Company/SaveClientList',
    method:'post',
    data:data
  })
}
function SaveCompanyCert(data)
{
  return request({
    url:'Company/SaveCompanyCert',
    method:'post',
    data:data
  })
}
async function GetCompanyRegions(LangId,Type){
  return await request({
    url: 'Company/GetCompanyRegions',
    method: 'get',
    params: {"LangId":LangId,"Type":Type}
  });

}
function GetProductAndAdCheckItem(query) {
  return request({
    url: 'Company/GetProductAndAdCheckItem',
    method: 'get',
    params: query
  });
}
function GetCompanyLogo(companyId)
{
  return request({
    url: 'Company/GetCompanyLogo',
    method: 'post',
    params: {"companyId":companyId}
  })
}

function SyncCompanyToFrontEnd(data)
{
  return request({
    url: 'Company/SyncCompanyToFrontEnd',
    method: 'post',
    data: data
  })
}

function GetCompanyApprovalStatus(query) {
  return request({
    url: 'Company/GetCompanyApprovalStatus',
    method: 'get',
    params: query,
  });
}

function GetCompanyApprovalDetail(data) {
  return request({
    url: 'Company/GetCompanyApprovalDetail',
    method: 'post',
    data,
  });
}

function UpdateCompanyRejectReason(data) {
  return request({
    url: 'Company/UpdateCompanyRejectReason',
    method: 'post',
    data,
  });
}

function UpdateCompanyOverallRejectReason(data) {
  return request({
    url: 'Company/UpdateCompanyOverallRejectReason',
    method: 'post',
    data,
  });
}

function CompanyApprove(data) {
  return request({
    url: 'Company/CompanyApprove',
    method: 'post',
    data,
  });
}

function DelistCompany(query) {
  return request({
    url: 'Company/DelistCompany',
    method: 'get',
    params: query,
  });
}